import { useQuery } from "@tanstack/react-query";
import { getScenarioOutputRoot, getOutputModelDataChildren } from "../../api/output";
import { getSensitivity } from "../../api/scenarios";

export const OUTPUT_ROOT_QUERY_KEY = ["outputRoot"] as const;
export const OUTPUT_CHILDREN_QUERY_KEY = ["outputChildren"] as const;

export function useScenarioOutputRoot(
  scenarioId: number,
  computeGeneration?: number,
) {
  return useQuery({
    queryKey: [...OUTPUT_ROOT_QUERY_KEY, scenarioId, computeGeneration],
    queryFn: () => getScenarioOutputRoot(scenarioId),
    enabled: scenarioId > 0,
    staleTime: 0,
  });
}

export function useSensitivityData(sensitivityId: number, computeGeneration?: number) {
  return useQuery({
    queryKey: ["sensitivityData", sensitivityId, computeGeneration],
    queryFn: () => getSensitivity(sensitivityId),
    enabled: sensitivityId > 0,
    staleTime: 0,
  });
}

export function useOutputModelDataChildren(modelDataId: number) {
  return useQuery({
    queryKey: [...OUTPUT_CHILDREN_QUERY_KEY, modelDataId],
    queryFn: () => getOutputModelDataChildren(modelDataId),
    enabled: modelDataId > 0,
    staleTime: 0,
  });
}
